import { mapState, mapGetters } from 'vuex';
// https://vuejs.org/v2/style-guide/#Private-property-names-essential

export default {
  computed: {
    ...mapState({
      $_isLoggedIn: state => state.user.isLoggedIn,
    }),
    ...mapGetters({
      isLoggedInButUnactivated: 'user/isLoggedInButUnactivated',
    }),
  },
  methods: {
    validateAccount() {
      if (!this.$_isLoggedIn) {
        this.$store.dispatch('modal/showSignUp');
        return false;
      }
      return true;
    },
  },
};
